import React from 'react';
import LazyMount from 'react-lazy-mount';
import { Drawer, Divider } from '@material-ui/core';
import { createStyles, makeStyles } from '@material-ui/styles';
import { JupiterTheme, NAVBAR_HEIGHT } from '@jupiterone/jupiter-web-toolkit';
import { InAppNotification } from '@jupiterone/notification-types';
import NotificationCard from 'navbar/src/notifications/NotificationsDrawer/NotificationCard';
import DrawerAppBar from 'navbar/src/notifications/NotificationsDrawer/DrawerAppBar';

const NOTIFICATIONS_DRAWER_WIDTH = '30%';
const NOTIFICATIONS_DRAWER_MIN_WIDTH = 430;
const NOTIFICATIONS_DRAWER_MAX_WIDTH = 500;

const useStyles = makeStyles((theme: JupiterTheme) =>
  createStyles({
    paper: {
      height: `calc(100vh - ${NAVBAR_HEIGHT}px)`,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      background: theme.palette.background.main,
      marginTop: `${NAVBAR_HEIGHT}px`,
      marginBottom: theme.spacing(1),
      width: NOTIFICATIONS_DRAWER_WIDTH,
      minWidth: NOTIFICATIONS_DRAWER_MIN_WIDTH,
      maxWidth: NOTIFICATIONS_DRAWER_MAX_WIDTH,
    },
    notifications: {
      overflowY: 'auto',
    },
    divider: {
      backgroundColor: theme.palette.grey[700],
      height: theme.spacing(0.125),
      width: '100%',
    },
  })
);

type NotificationsDrawerProps = {
  loading: boolean;
  isDrawerOpen: boolean;
  notifications: InAppNotification[];
  handleClose: () => void;
  handleNotificationClick: (notificationId: string, actionLink: string) => void;
};
const NotificationsDrawer = ({
  isDrawerOpen,
  notifications,
  handleClose,
  handleNotificationClick,
}: NotificationsDrawerProps) => {
  const classes = useStyles();

  return (
    <Drawer
      variant="persistent"
      anchor="right"
      open={isDrawerOpen}
      classes={{
        paper: classes.paper,
      }}
    >
      <LazyMount trigger={isDrawerOpen}>
        <DrawerAppBar handleClose={handleClose} />
        <div className={classes.notifications}>
          {notifications.map((notification) => (
            <div key={notification.notificationId}>
              <NotificationCard
                key={notification.notificationId}
                onClick={() =>
                  handleNotificationClick(
                    notification.notificationId,
                    notification.actionLink
                  )
                }
                {...notification}
              />
              <Divider className={classes.divider} />
            </div>
          ))}
        </div>
      </LazyMount>
    </Drawer>
  );
};

export default NotificationsDrawer;
